import React from "react";

const SvgBlockStyleCopy = props => (
  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
    viewBox="0 0 24 24"  {...props}><path d="M3,14.5H21a1,1,0,0,0,1-1v-1A2.5,2.5,0,0,0,19.5,10H14.829a.251.251,0,0,1-.249-.275l.619-6.19a3.215,3.215,0,1,0-6.4,0l.619,6.19a.253.253,0,0,1-.063.193A.251.251,0,0,1,9.172,10H4.5A2.5,2.5,0,0,0,2,12.5v1A1,1,0,0,0,3,14.5ZM13,3.75a1,1,0,1,1-1-1A1,1,0,0,1,13,3.75Z" /><path d="M22.368,22.459A8.6,8.6,0,0,1,21,17.8V16.5a.5.5,0,0,0-.5-.5H3.5a.5.5,0,0,0-.5.5v1.3A8.607,8.607,0,0,1,1.632,22.46,1,1,0,0,0,2.474,24H3.968A3.494,3.494,0,0,0,6.88,22.442c.212-.317.439-.662.66-1a.25.25,0,0,1,.46.136V23a1,1,0,0,0,1,1H21.526A1,1,0,0,0,22.368,22.459Z" /></svg>
);

export default SvgBlockStyleCopy;
